import EmailLogSearchContainer from './email-log-search.container';

export default EmailLogSearchContainer;
